import { lowerCase } from 'lodash';

import { ISchedule } from 'shared/domain/entities';

interface IVectisScheduleItem {
  id: number;
  nome: string;
  sessaoCorrente: number;
  totalSessoes: number;
  imagens: {
    feminino: { alta: string; baixa: string };
    masculino: { alta: string; baixa: string };
  };
  dataMinimaParaAgendamento: string;
}

export interface IVectisSchedule {
  id: number;
  data: string;
  hora: string;
  unidade: string;
  enderecoUnidade: string;
  status: string;
  motivoCancelamento?: string;
  sexo: 'MASCULINO' | 'FEMININO' | 'UNISEX';
  areas: IVectisScheduleItem[];
}

export class Schedule implements ISchedule {
  public id: ISchedule['id'];
  public date: ISchedule['date'];
  public time: ISchedule['time'];
  public areas: ISchedule['areas'];
  public status: ISchedule['status'];
  public cancellationReason: ISchedule['cancellationReason'];
  public unit: ISchedule['unit'];

  constructor({
    id,
    data,
    hora,
    areas,
    sexo,
    unidade,
    status,
    motivoCancelamento,
    enderecoUnidade,
  }: IVectisSchedule) {
    const gender = lowerCase(sexo);
    const imageGender = gender === 'unisex' ? 'feminino' : gender;

    this.id = id;
    this.date = this.formatDate(data);
    this.unit = { name: unidade, address: enderecoUnidade };
    this.status = status;
    this.cancellationReason = motivoCancelamento;
    this.time = hora;
    this.areas = areas.map(area => ({
      id: area.id,
      name: area.nome,
      session: {
        done: area.sessaoCorrente,
        next: area.sessaoCorrente + 1,
        total: area.totalSessoes,
      },
      image: area.imagens[imageGender].alta,
      availableDate: new Date(area.dataMinimaParaAgendamento),
    }));
  }

  private formatDate(date: string) {
    if (!date) return new Date(Date.now());

    const [day, month, year] = date.split('/');

    return new Date(Number(year), Number(month) - 1, Number(day));
  }
}
